import { Input } from 'antd';
import { Button } from '../../../../../design-system';
import React, { useEffect, useState } from 'react';
import { useSelected } from '../../../../../providers/selectedContext';
import { useTheme } from '../../../../../providers/theme';
import { getColors } from '../../../../utils/getColors';

interface MeanValueProps {
  mean: number | null | undefined;
  savedMean: number | null | undefined;
  setMean: React.Dispatch<React.SetStateAction<number | null | undefined>>;
  setSavedMean: React.Dispatch<React.SetStateAction<number | null>>;
  type: string;
}

export const calculateMean = (data: number[]): number => {
  if (!data.length) return 0;
  const sum = data.reduce((total, item) => total + item, 0);
  return sum / data.length;
};

const MeanValue = (props: MeanValueProps) => {
  const { isDay } = useTheme();
  const colors = getColors(isDay);
  const { selectedInfo, setSelectedInfo } = useSelected();
  const updatedSample = selectedInfo?.sample;
  const [edit, setEdit] = useState(false);
  const [newMean, setNewMean] = useState<string | undefined>(
    props.mean?.toFixed(4)
  );
  const typeValue = props.type === 'No' ? 'no_w' : 'nw';

  useEffect(() => {
    setNewMean(props.mean?.toFixed(4));
  }, [props.mean]);

  const handleClick = () => {
    if (edit && newMean) {
      const newMeanValue = Number(newMean);
      props.setMean(newMeanValue);
      props.setSavedMean(newMeanValue);
    }
    setEdit(!edit);
  };

  return (
    <div
      className="mean-container"
      style={{ border: `1px solid ${colors.border}` }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <p>{props.type} Value:</p>
          {!edit ? (
            <p className="mean-div">{props.mean?.toFixed(4)}</p>
          ) : (
            <Input
              value={newMean}
              onChange={e => setNewMean(e.target.value)}
              style={{ width: '50%', marginLeft: '0.5rem' }}
            />
          )}
        </div>
        <p style={{ marginTop: '0.5rem' }}>
          {props.type} Saved: <span>{props.savedMean?.toFixed(4) || 'N/A'}</span>
        </p>
      </div>
      <div>
        <Button variant="secondary" onClick={handleClick}>{!edit ? 'Edit' : 'Save'}</Button>
      </div>
    </div>
  );
};

export default MeanValue;
